import {
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiPill
} from "@mdi/js";

export default Object.freeze({
    AREAS_OF_INTEREST: [
        { id: 1, description: 'Oncologia' },
        { id: 2, description: 'Dermatologia' },
        { id: 3, description: 'Patologia clínica' },
        { id: 4, description: 'Patologia Geral' },
        { id: 5, description: 'Radiologia' },
        { id: 6, description: 'Traumatologia' },
        { id: 7, description: 'Ortopedia' },
        { id: 8, description: 'Neurologia' },
        { id: 9, description: 'Cirurgia' },
        { id: 10, description: 'Homeopatia' },
        { id: 11, description: 'Fitoterapia' },
        { id: 12, description: 'Endocrinologia' },
        { id: 13, description: 'Pneumologia' },
        { id: 14, description: 'Cardiologia' },
        { id: 15, description: 'Gastroenterologia' },
        { id: 16, description: 'Fisiatria' },
        { id: 17, description: 'Etologia' },
        { id: 18, description: 'Nefrologia' },
        { id: 19, description: 'Nutrição' },
        { id: 20, description: 'Clínica Geral' },
        { id: 21, description: 'Epidemiologia' },
        { id: 22, description: 'Geriatria' },
        { id: 23, description: 'Obstetrícia' },
        { id: 24, description: 'Anestesiologia' },
        { id: 25, description: 'Intensivismo' },
        { id: 26, description: 'Oftalmologia' },
        { id: 27, description: 'Medicina Felina' }
    ],
    ACADEMIC_DEGREES: [
        { id: 11, description: 'Graduação (Em curso)' },
        { id: 12, description: 'Graduação (Concluída)' },        
        { id: 9, description: 'Residência (Em curso)' },
        { id: 10, description: 'Residência (Concluída)' },
        { id: 1, description: 'Especialização (Em curso)' },
        { id: 2, description: 'Especialização (Concluída)' },
        { id: 3, description: 'Aperfeiçoamento (Em curso)' },
        { id: 4, description: 'Aperfeiçoamento (Concluído)' },
        { id: 5, description: 'Mestrado (Em curso)' },
        { id: 6, description: 'Mestrado (Concluído)' },
        { id: 7, description: 'Doutorado (Em curso)' },
        { id: 8, description: 'Doutorado (Concluído)' },
    ],
    VETERINARY_STATUS: {
        professional: { id: 1, description: 'Profissional' },
        student: { id: 2, description: 'Graduando' },
        others: { id: 3, description: 'Outros' },
    },
    DRUGS_TABS: [
        {
            name: "Info",
            icon: mdiAlertCircleOutline,
            value: 0
        },
        {
            name: "Doses",
            icon: "$vuetify.icons.doses",
            value: 1
        },
        {
            name: "Atenção",
            icon: mdiAlertOutline,
            value: 2
        },
        {
            name: "Produtos",
            icon: mdiPill,
            value: 3,
            products: true
        }
    ]
});